import { render } from "./addHole.vue?vue&type=template&id=a2112a02&scoped=true"
import script from "./addHole.vue?vue&type=script&lang=js"
export * from "./addHole.vue?vue&type=script&lang=js"

import "./addHole.vue?vue&type=style&index=0&id=a2112a02&lang=css"
import "./addHole.vue?vue&type=style&index=1&id=a2112a02&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2112a02"]])

export default __exports__